module.exports = __webpack_public_path__ + "static/media/awepayIcon.82a0c96b.svg";